import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type {
  Client,
  Project,
  Services,
  Ticket,
  User,
  UserLimitedList,
} from "../../app/generated-axios-client";

interface DashboardState {
  tickets: Ticket[];
  assigneeById: Record<number, UserLimitedList>;
  serviceById: Record<string, Services>;
  projects: Project[];
  clientById: Record<string, Client>;
  technicians: User[];
  loading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  tickets: [],
  assigneeById: {},
  serviceById: {},
  projects: [],
  clientById: {},
  technicians: [],
  loading: false,
  error: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    fetchDashboard: (state) => {
      state.loading = true;
      state.error = null;
    },
    storeDashboard: (
      state,
      action: PayloadAction<{
        tickets: Ticket[];
        assigneeById: Record<number, UserLimitedList>;
        serviceById: Record<string, Services>;
        projects: Project[];
        clientById: Record<string, Client>;
        technicians: User[];
      }>,
    ) => {
      state.tickets = action.payload.tickets;
      state.assigneeById = action.payload.assigneeById;
      state.serviceById = action.payload.serviceById;
      state.projects = action.payload.projects;
      state.clientById = action.payload.clientById;
      state.technicians = action.payload.technicians;
      state.loading = false;
      state.error = null;
    },
    setDashboardError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const dashboardActions = dashboardSlice.actions;
export default dashboardSlice.reducer;
